export default __webpack_public_path__ + "static/media/granville18.98fd86e8.jpg";